export default __webpack_public_path__ + "static/media/vinho rosé.051f7590.png";